// extracted by mini-css-extract-plugin
export default {"icon":"DaskIcon_icon__x-Yeo"};